import styled from 'styled-components';

export const SectionLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
